import {
    Component
} from '@angular/core';
import {
    NavController
} from 'ionic-angular';
import {
    INICIO_PAGE,
    NOSOTROS_PAGE,
    CONTACTO_PAGE
} from '../../pages/pages.constants';

@Component({
    selector: 'footer',
    templateUrl: 'footer.html'
})
export class FooterComponent {

    constructor(private _nav: NavController) {}

    irA(pagina) {
        switch (pagina) {
            case 'Inicio':
                this._nav.setRoot(INICIO_PAGE);
                break;
            case 'Nosotros':
                this._nav.push(NOSOTROS_PAGE);
                break;
            case 'Contacto':
                this._nav.push(CONTACTO_PAGE);
                break;
            default:
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/footer/footer.ts